import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {OrderFeedback} from "../interface/order-feedback";
import {ToastMessageService} from "../../services/toast-message.service";
import {AddOrderTransmissionService} from "../../raintree/transmission/order-transmission/order-transmission.service";
import {ActivatedRoute, Router} from "@angular/router";
import {StoreForexService} from "../../navigation/service/store-forex.service";
import {isPlatformBrowser} from "@angular/common";
import {RequestMapperService} from "../../request-mapper.service";
import {CustomOrderDetails} from "../interface/custom-order-details";
import {CustomOrderItem} from "../interface/custom-order-item";

@Component({
	selector: 'fb-profile-custom-order',
	templateUrl: './profile-custom-order.component.html',
	styleUrls: ['./profile-custom-order.component.scss', '../profile-order/profile-order.component.scss']
})
export class ProfileCustomOrderComponent implements OnInit {

	@Input()
	public showHeader: boolean = true;

	public orderDetails: CustomOrderDetails | null = null;
	public orderId: number = -1;
	public reviewOrderItemId: number = -1;
	public orderItemId: number = -1;
	public madeToOrderItem: CustomOrderItem[] = [];
	public isBrowser: boolean = false;
	public showOrderInformation: boolean = false;
	public isLoading: boolean = true;
	public orderFeedback: OrderFeedback | null = null;
	public sortOrderSection: string[] = [];

	constructor(
		public _toast: ToastMessageService,
		private _orderTransmision: AddOrderTransmissionService,
		private _route: ActivatedRoute,
		public storeForex: StoreForexService,
		private _router: Router,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	public ngOnInit(): void {

		this._route.params.subscribe(params => {
			this.getOrderDetails(params['id']);
			this.orderId = params['id'];
		});

		this._route.queryParams.subscribe(params => {
			this.reviewOrderItemId = params['review'];
			this.orderItemId = +params['item'];
		});
	}

	public getOrderDetails(id: string) {
		this._orderTransmision.getCustomOrderById(
			RequestMapperService.GET_BY_ID_CUSTOM_ORDER + id,
			() => {
				//success
			},
			() => {
				//error
			},
			(response: CustomOrderDetails) => {
				this.orderDetails = response;
				if(this.orderDetails.adjustments && this.orderDetails.adjustments.length > 0) {
					this.orderDetails.adjustments.sort((a, b) => a.sortOrder - b.sortOrder);
				}
				this.sortByOrderType();
			},
			() => {
			},
			() => {
			}
		)
	}

	public sortByOrderType(): void {

		if (!this.orderDetails) return;

		this.orderDetails.orderItems.sort((a, b) => b.updatedAt - a.updatedAt);
		this.orderDetails.orderItems.forEach((elm: CustomOrderItem) => {
			if(!this.sortOrderSection.includes(elm.orderType)) {
				this.sortOrderSection.push(elm.orderType);
			}

			if (elm.orderType === 'MADE_TO_ORDER') {
				this.madeToOrderItem.push(elm);
			}
		});

		this.isLoading = false;
	}
}
